<template lang="pug">
div.cardInformacoes(class="card", v-if="processo")
  Vincular-Pessoa(v-if="showSincronizar", :processo="processo", @cancelar="showSincronizar = false", @atualizarProcesso="atualizarProcesso")
  app-modal-retificacao-cadastro(
    v-if="visualizarModalRetificacao",
    @closeModal="closeModal",
    :idProcesso="processo.id"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso",
    @closeModal="closeModalVisualizar()",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso",
    :isCentralInteressado="true"
  )
  .card-header Informações do cadastro
    el-col(:span="24" v-if="isInteressado && switchHabilitar")
      .containerBotaoHabilitar
        div
          p {{ isAmapa() ? 'Habilitar visualização do processo ao cadastrante' : 'Habilitar cadastrante' }}</p>
          el-switch(
            v-model="isSwitchAtivado"
            active-color="#13ce66"
            @change="ativarDesativar"
          )
    div.marginTop
      el-dropdown(trigger='click', v-if="!isCadastroPendente")
        el-button(type='info', size='small') Opções
            i.el-icon-arrow-down.el-icon--right
        el-dropdown-menu(slot='dropdown')
          el-dropdown-item(v-if=" !downloadCcr && showButtonOficio", :class="{ 'disabled': !downloadCcr }")
            .flex(
              @click="emitirOficioCcr()"
            )
              span.center
                i.fal.fa-download
                  | &nbsp Ofício cancelamento de cláusula resolutiva
          el-dropdown-item
            .flex(
              @click="emitirSegundaVia",
              @emitirSegundaVia="emitirSegundaVia()"
            )
              span.center
                i.fal.fa-download
                | &nbsp Segunda via do comprovante de envio
          el-dropdown-item(v-if="isRetificaoCadastro()")
            .flex(
              @click="openModal",
            )
              span.center
                i.fal.fa-sync-alt
                | &nbsp Retificar Cadastro
          el-dropdown-item(v-if="showRetificacaoCadastroOnline()")
            .flex(
              @click="navigateToCadastro",
            )
              span.center
                i.fal.fa-sync-alt
                | &nbsp Retificar Cadastro Online
          el-dropdown-item(v-if="isShowVincularPessoa() && visualizarBotaoVincularPessoa")
            .flex(
              @click="showSincronizar = true",
            )
              span.center
                i.fal.fa-sync-alt
                | &nbsp Vincular pessoa
          el-dropdown-item(v-if="visualizaProcesso")
            .flex(
              @click="visualizarProcesso",
            )
              span.center
                i.fal.fa-eye
                | &nbsp Visualizar Processo
          el-dropdown-item(v-if="isMaranhao() && (isCacelamentoDeClausulaResolutiva() || isProcessoFisico())")
            .flex(
              @click="retificararProcesso",
            )
              span.center
                i.fal.fa-sync-alt
                | &nbsp Retificar Processo
          el-dropdown-item(v-if="isAmapa() && isInteressado")
            .flex(
              @click="solicitarCopia",
            )
              span.center
                i.fal.fa-file
                | &nbsp Solicitar cópia do processo
  div(class="card-body")
    cadastro-online(v-if="getIsOnline()" :processo="processo", :idProcesso="processo.id")
    cadastro-offline(v-else :processo="processo" :isCadastroPendente="isCadastroPendente")
</template>
<script>

import CadastroOffline from '@/components/InformacoesCadastroOffline'
import AppModalRetificacaoCadastro from '@/screens/analise/components/AppModalRetificacaoCadastro'
import CadastroOnline from '@/components/informacoesCadastro/cadastrosOnline/InformacoesCadastroOnline'
import VincularPessoa from '@/screens/central/processos/VincularPessoa'
import { mapActions, mapGetters } from 'vuex'
import FileHelper from '@/utils/fileHelper'
import axios from '@/utils/api'
import AppNotificacao from './mixins/AppNotificacao.vue'

const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const regrasCentral = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {

  components: {
    CadastroOffline,
    CadastroOnline,
    AppModalRetificacaoCadastro,
    FileHelper,
    VincularPessoa
  },

  mixins: [
    AppNotificacao
  ],

  async created () {
    if (this.isCadastroPendente) {
      const cadastroProvisorioAux = await this.getCadastroProvisorioByRecibo(this.$route.params.idCadastro)
      const jsonCadastro = JSON.parse(cadastroProvisorioAux.jsonCadastro)

      if (cadastroProvisorioAux.analiseGeorreferenciamento) {
        cadastroProvisorioAux.analiseGeorreferenciamento.possuiGeorreferenciamento = 'POSSUI'
        cadastroProvisorioAux.analiseGeorreferenciamento.localizacoes = []
        jsonCadastro.dados.cadastro.georreferenciamento = cadastroProvisorioAux.analiseGeorreferenciamento
      }
      jsonCadastro.dados.cadastro.tipo = cadastroProvisorioAux.tipo.codigo
      jsonCadastro.dados.cadastro.protocolo = cadastroProvisorioAux.numeroRecibo
      this.processo = {
        dadosCadastro: jsonCadastro,
        tipo: cadastroProvisorioAux.tipo,
        pessoas: cadastroProvisorioAux.pessoas,
        dataCadastro: cadastroProvisorioAux.dataCriacao
      }
    } else {
      this.processo = await this.getProcessoByProtocolo(this.$route.params.idCadastro)
      const flagsFormatada = typeof this.processo?.jsonFlags === 'string' ? JSON.parse(this.processo?.jsonFlags) : this.processo?.jsonFlags
      this.isSwitchAtivado = flagsFormatada?.cadastranteVisualizaProcesso
      if (this.processo.status === 'PROCESSO_DEFERIDO') {
        await axios({
          method: 'get',
          url: `despacho/pdf/oficio/processo/${this.processo.id}`,
          responseType: 'arraybuffer'
        }).then(res => {
          this.bytes = res
          this.downloadCcr = true
        })
      }
    }
    const usuario = await this.getUsuario()
    this.isInteressado = this.cadastroOriginal?.interessado.pessoa.isPessoaFisica ? this.cadastroOriginal?.interessado.pessoa.pessoaFisica.cpf === usuario.pessoa.cpfCnpj
      : this.cadastroOriginal?.interessado.pessoa.pessoaJuridica?.cnpj === usuario.pessoa.cpfCnpj

    this.isCadastrante = this.cadastroOriginal?.cadastrante.pessoa.isPessoaFisica ? this.cadastroOriginal?.cadastrante.pessoa.pessoaFisica.cpf === usuario.pessoa.cpfCnpj
      : this.cadastroOriginal?.cadastrante.pessoa.pessoaJuridica?.cnpj === usuario.pessoa.cpfCnpj
  },

  data () {
    return {
      buttonOpcoes: regrasCentral.buttonOpcoes.showButonVisualizarProcesso,
      switchHabilitar: regrasCentral.switchHabilitar.showSwitchHabilitar,
      showButtonOficio: regrasCentral.showButtonOficio,
      processo: null,
      visualizarModalRetificacao: false,
      downloadCcr: false,
      bytes: '',
      showSincronizar: false,
      showModalVisualizarProcesso: false,
      visualizarBotaoVincularPessoa: regrasAnalise.visualizarBotaoVincularPessoa,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      isSwitchAtivado: false,
      flagsFormatada: false,
      isInteressado: true,
      isCadastrante: true
    }
  },

  props: {
    isCadastroPendente: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    cadastroOriginal () {
      if (this.getIsOnline()) {
        if (!this.processo) {
          return null
        }

        return { ...this.processo.dadosCadastro, protocolo: this.processo.numeroProtocolo, tipo: this.processo.tipo.codigo }
      }
      return this.processo.dadosCadastro.dados?.cadastro
    },

    visualizaProcesso () {
      if (this.buttonOpcoes) {
        if (this.isInteressado || (!this.isInteressado && !this.isCadastrante) || (this.isSwitchAtivado && this.isCadastrante)) {
          return true
        }
      }
      return false
    }
  },

  methods: {
    ...mapActions({
      gerarSegundaVia: 'cadastro/emitirSegundaVia',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      getCadastroProvisorioByRecibo: 'cadastroProvisorio/getCadastroProvisorioByRecibo',
      getUsuario: 'auth/getUsuario',
      criarMensagem: 'conversa/criarMensagem',
      retificar: 'processo/retificarProcesso'
    }),

    navigateToCadastro () {
      const isThisProcessoSemSolicitacao = this.processo.jsonFlags === null || this.processo.jsonFlags.isRetificadoSemSolicitacao === null || (!this.processo.status.includes('RETIFICACAO') && (this.processo.jsonFlags.isRetificadoSemSolicitacao || !this.processo.jsonFlags.isRetificadoSemSolicitacao))
      if (
        isThisProcessoSemSolicitacao && this.usuario.perfilSelecionado.codigo === 'RECEPTOR'
      ) {
        this.retificar(this.montarConversa())
      }
      const id = this.processo.id
      if (this.usuario.perfilSelecionado.codigo === 'RECEPTOR') {
        this.$router.push({ name: 'receptor/retificacao/cadastrante', params: { id } })
      } else {
        this.$router.push({ name: 'retificacao/cadastrante', params: { id } })
      }
    },

    async ativarDesativar () {
      await axios({
        method: 'GET',
        url: `processo/ativarDesativarVisualizacaoCadastrante/${this.processo.id}/${this.isSwitchAtivado}`
      })
    },

    getIsOnline () {
      return (this.processo.tipo.codigo === 'PERMUTA' ||
              this.processo.tipo.codigo === 'INFORMACOES' ||
              this.processo.tipo.codigo === 'TRANSFERENCIA_DIREITOS' ||
              this.processo.tipo.codigo === 'AFORAMENTO' ||
              this.processo.tipo.codigo === 'AREAS_PATRIMONIAIS' ||
              this.processo.tipo.codigo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
      )
    },

    isCacelamentoDeClausulaResolutiva () {
      return this?.processo?.retificacao && ['CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'REURB_COLETIVO'].includes(this?.processo?.tipo?.codigo)
    },

    isProcessoFisico () {
      return this?.processo?.retificacao && ['NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'].includes(this?.processo?.tipo?.codigo)
    },

    isRetificaoCadastro () {
      if (this.isMaranhao()) {
        return this?.processo?.retificacao &&
        !['ARQUIVADO'].includes(this?.processo?.status) &&
        !['CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'REURB_COLETIVO', 'REURB_INDIVIDUAL', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'].includes(this?.processo?.tipo?.codigo) &&
        !this.isUsuarioExterno()
      }
      return !this.processo?.jsonFlags?.isRetificadoSemSolicitacao && this?.processo?.retificacao && !['ARQUIVADO'].includes(this?.processo?.status) && !['CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'REURB_COLETIVO', 'REURB_INDIVIDUAL', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'].includes(this?.processo?.tipo?.codigo)
    },

    isUsuarioExterno () {
      return this.usuario?.hasPerfilExterno
    },

    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },

    isAmapa () {
      return process.env.ESTADO === 'ap'
    },

    closeModalVisualizar () {
      this.showModalVisualizarProcesso = false
      this.atualizarProcesso()
    },

    openModal () {
      this.visualizarModalRetificacao = true
    },

    visualizarProcesso () {
      this.showModalVisualizarProcesso = true
      this.idProcesso = this.processo.id
      this.numeroProcesso = this.processo.numeroProcesso
      this.tipoProcesso = this.processo.tipo.codigo
      this.protocolo = this.processo.numeroProtocolo
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : 'receptor/'
    },

    montarConversa () {
      const objeto = {
        conversa: {
          assunto: 'Retificação realizada pelo ITERPA',
          processo: {
            id: this.processo.id
          },
          mensagemList: [
            {
              conteudo: '<p>Este processo passou por uma retificação realizada pelo ITERPA.</p>',
              anexosList: []
            }
          ]
        },
        setor: this.processo.setor,
        tipoConversaEnum: 'SOLICITACAO_RETIFICACAO',
        isRetificacaoOnline: true
      }
      return objeto
    },

    async retificararProcesso () {
      const rota = this.isProcessoFisico() ? 'processo-fisico' : 'liberacao-clausula'
      await this.$router.push({
        name: this.formataRots() + `${rota}/cadastrante`,
        params: {
          idCadastro: this?.processo?.dadosCadastro?.id,
          isRetificacao: true
        }
      })
    },

    closeModal () {
      this.visualizarModalRetificacao = false
    },

    emitirSegundaVia () {
      const params = {
        protocoloCadastro: this.cadastroOriginal.protocolo,
        nomeInteressado: this.cadastroOriginal.interessado.pessoa.pessoaFisica
          ? this.cadastroOriginal.interessado.pessoa.pessoaFisica.nome : this.cadastroOriginal.interessado.pessoa.pessoaJuridica.razaoSocial,
        tipo: this.getTipoProcesso()
      }
      this.gerarSegundaVia(params)
    },

    async emitirOficioCcr () {
      FileHelper.saveFile(this.bytes, 'Ofício - Cancelamento de Clausula Resolutiva')
    },

    getTipoProcesso () {
      switch (this.cadastroOriginal.tipo) {
        case 'NAO_ONEROSO':
          return 'Não Oneroso'
        case 'ONEROSO':
          return 'Oneroso'
        case 'PEAS':
          return 'PEAS'
        case 'PEAEX':
          return 'PEAEX'
        case 'TEQ':
          return 'TEQ'
        case 'CERTIDAO_TITULO':
          return 'Certidão de Título'
        case 'AREAS_PATRIMONIAIS':
          return 'Áreas Patrimoniais'
        case 'INFORMACOES':
          return 'Informação'
        case 'PERMUTA':
          return 'Permuta'
        case 'TRANSFERENCIA_DIREITOS':
          return 'Transferência de Direitos'
        case 'AFORAMENTO':
          return 'Aforamento'
        default:
          return this.cadastroOriginal.tipo
      }
    },
    isShowVincularPessoa () {
      return this.$router.history.current.name === 'informacoesCadastro'
    },
    async atualizarProcesso () {
      this.processo = await this.getProcessoByProtocolo(this.$route.params.idCadastro)
    },
    solicitarCopia () {
      this.confirmBox(this.$messages.SOLICITAR_COPIA, this.$messages.TITULO_WARNING,
        this.enviarSolicitacaoCopia,
        () => { }, 'Enviar')
    },
    async enviarSolicitacaoCopia () {
      try {
        const mensagem = {
          assunto: 'SOLICITACAO_DE_COPIA_DO_PROCESSO',
          tipo: 'OUVIDORIA',
          mensagemList: [
            {
              conteudo: `Solicito cópia do meu processo ${this.processo.numeroProcesso}.`
            }
          ],
          id: this.idConversa ? this.idConversa : null
        }

        await this.criarMensagem(mensagem)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Solicitação de cópia enviada com sucesso')
        this.$router.push({ name: 'central/comunicacao' })
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao enviar solicitação de cópia.')
      }
    },

    isStatusPraRetificar () {
      // LISTA DE STATUS DO PROCESSO, QUE NÃO PODE REALIZAR A RETIFICAÇÃO
      const listaStatusProcesso = [
        'AGUARDANDO_CONFERENCIA_CERTIDAO', 'AGUARDANDO_CONFERENCIA_TITULO', 'AGUARDANDO_CALCULO_CUSTAS',
        'AGUARDANDO_ASSINATURA', 'AGUARDANDO_ENTREGA', 'AGUARDANDO_ENTREGA_TITULO', 'ENTREGUE',
        'AGUARDANDO_RETIFICACAO_TITULO', 'FINALIZADO', 'AGUARDANDO_ASSINATURA_TITULO', 'ASSINADO_RETIFICACAO_TITULO',
        'AGUARDANDO_ASSINATURA_RETIFICACAO_TITULO', 'AGUARDANDO_ATUALIZACAO_BASE', 'EM_ATUALIZACAO_BASE',
        'ARQUIVADO_AGUARDANDO_ANALISE', 'ARQUIVADO', 'ARQUIVADO_EM_REVISAO', 'ARQUIVADO_AGUARDANDO_GERACAO_DOCUMENTO',
        'AGUARDANDO_VALIDACAO_BASE', 'AGUARDANDO_PAGAMENTO_DESARQUIVAMENTO', 'EM_RETIFICACAO_ARQUIVADO',
        'AGUARDANDO_RESPOSTA_INTERESSADO', 'AGUARDANDO_BOLETO', 'AGUARDANDO_CALCULO_VTN', 'AGUARDANDO_GERACAO_DOCUMENTOS',
        'AGUARDANDO_OS', 'AGUARDANDO_ANALISE_VISTORIA_REMOTA', 'EM_ANALISE_VISTORIA_REMOTA'
      ]
      return !listaStatusProcesso.includes(this.processo.status)
    },

    showRetificacaoCadastroOnline () {
      const { tipo, retificacao, perfil, jsonFlags } = this.processo
      const perfilSelecionado = this.usuario.perfilSelecionado.codigo
      const isShowRetificacao = this.isStatusPraRetificar()

      if (!regrasAnalise.hasRetificacaoOnline) {
        return false
      }

      // Verifica o tipo de processo
      if (tipo.codigo !== 'NAO_ONEROSO' && tipo.codigo !== 'ONEROSO') {
        return false
      }

      // Verifica se o usuário externo pode acessar retificação
      if (perfilSelecionado === 'EXTERNO' && isShowRetificacao && retificacao && !jsonFlags?.isRetificadoSemSolicitacao) {
        return true
      }

      // Verifica se o usuário receptor pode acessar retificação
      return perfilSelecionado === 'RECEPTOR' && isShowRetificacao && perfil !== 'TECNICO_DE_CAMPO'
    }
  }

}
</script>
<style lang="scss" scoped>

.card-header {
  padding: 23px;
  box-sizing: border-box;
  align-items: center;
  font-size: 1.2em;
  padding-bottom: 0;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 5px 0 10px 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.containerBotaoHabilitar{
  display: flex;
  flex-direction: row-reverse;

  div {
    text-align: center;
    margin-right: 5%;
  }

  p {
    font-weight: 100;
  }
}

@media (max-width: 780px) {
  .cardInformacoes {
    position: relative;
    width: 300px;
  }

  .marginTop {
    margin-top: 15px;
  }

  .containerBotaoHabilitar {
    margin-top: 5%;
    flex-direction: column;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/InformacoesCadastro.vue